<section class="project-tab-section">
  <div class="project-tab-section__toolbar">
    <div class="project-tab-section__intro">
      <h2 class="project-tab-section__title">Users</h2>
      <p class="project-tab-section__subtitle">
        Non-admin users in this project can be scoped to its sources and agents. Admins already have full access.
      </p>
    </div>
  </div>

  <ng-container *allowedRole="'admin'">
    <div class="project-users-assign">
      <h3 class="project-users-assign__label">Assign users</h3>
      <app-users-selector (selectedUsers)="attachUsers($event)" />
    </div>
  </ng-container>

  <h3 class="project-users-list-heading">Assigned users</h3>

  @if (!isLoading) {
    @if (users.length === 0) {
      <div class="project-tab-empty project-tab-empty--compact">
        <p class="project-tab-empty__text">No users are assigned to this project yet.</p>
      </div>
    } @else {
      <div
        class="project-users-table"
        [class.project-users-table--no-actions]="!showActionsColumn"
        role="table"
        [attr.aria-label]="'Users assigned to project'"
      >
        <div class="project-users-table__header" role="row">
          <span role="columnheader">Username</span>
          @if (showActionsColumn) {
            <span class="project-users-table__col-actions" role="columnheader">Actions</span>
          }
        </div>
        @for (row of users; track row._id) {
          <div class="project-users-table__row" role="row">
            <span class="project-users-table__cell" role="cell">{{ row.username }}</span>
            @if (showActionsColumn) {
              <span class="project-users-table__col-actions" role="cell">
                <button
                  mat-stroked-button
                  color="warn"
                  type="button"
                  (click)="detachUser(row)"
                >
                  Remove
                </button>
              </span>
            }
          </div>
        }
      </div>
    }
  } @else {
    <app-spinner />
  }
</section>
